/** @format */

import {useState, useEffect, FocusEvent} from 'react';

import {TextField} from '@mui/material';

import {TextFieldProps} from '@mui/material/TextField';

import Hint from 'components/Hint';

import ErrorMessage from 'components/ErrorMessage';

import {MyProps} from './types';

export type BaseTextFieldProps = {
  myProps?: MyProps;
  errorText?: string | null;
} & TextFieldProps;

const BaseTextField = (props: BaseTextFieldProps) => {
  const [placeholder, setPlaceholder] = useState(props.placeholder);
  const {myProps, errorText, ...muiProps} = props;

  useEffect(() => {
    setPlaceholder(props.placeholder);
  }, [props.placeholder]);

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    setPlaceholder(muiProps.placeholder);

    if (props.onBlur) props.onBlur(e);
  };

  const handleFocus = () => {
    setPlaceholder(myProps?.placeholderFocused);
  };

  return (
    <>
      <TextField
        {...muiProps}
        className={props.className}
        placeholder={placeholder}
        onBlur={handleBlur}
        onFocus={handleFocus}
      />
      {myProps?.hint && <Hint text={myProps.hint} />}
      {errorText && <ErrorMessage text={errorText} />}
    </>
  );
};

export default BaseTextField;
